/**
 * Регламент осмотров флота.
 *
 * Решение владельца: осмотр обязателен по внутренней политике флота
 * (вариант 1 из разбора OOS-05). Юридически значима не сама обязательность,
 * а ПОЛНОТА журнала: объяснённый пропуск безопасен, молчаливый — нет.
 *
 * Отсюда две сущности в фундаменте: версионируемый текст регламента и
 * подтверждение ознакомления конкретным человеком с конкретной версией.
 */
import { z } from 'zod';
import { localeSchema, objectIdSchema } from './common.js';
export const policyTextSchema = z.object({
    title: z.string().min(1).max(300),
    body: z.string().min(1).max(50_000),
});
export const publishPolicySchema = z.object({
    /**
     * Текст по языкам. Водитель подтверждает то, что прочитал на своём языке,
     * — по той же причине, по которой шаблон осмотра вмораживается в запись.
     */
    // partialRecord, а не record: регламент может быть переведён не на все языки.
    texts: z.partialRecord(localeSchema, policyTextSchema),
    effectiveFrom: z.coerce.date(),
    /** Через сколько дней после публикации доступ водителя блокируется без подтверждения. */
    graceDays: z.number().int().min(0).max(90).default(7),
});
export const policySchema = z.object({
    id: objectIdSchema,
    orgId: objectIdSchema,
    version: z.number().int().positive(),
    texts: z.partialRecord(localeSchema, policyTextSchema),
    effectiveFrom: z.coerce.date(),
    graceDays: z.number().int(),
    publishedByUserId: objectIdSchema,
    publishedAt: z.coerce.date(),
});
export const acknowledgePolicySchema = z.object({
    version: z.number().int().positive(),
    locale: localeSchema,
    /**
     * SHA-256 текста, который был показан на экране. Подтверждает не «нажал кнопку»,
     * а «нажал кнопку под конкретным текстом» — иначе подпись ни к чему не привязана.
     */
    textHash: z.string().regex(/^[a-f\d]{64}$/i),
});
export const policyStatusSchema = z.object({
    hasPolicy: z.boolean(),
    currentVersion: z.number().int().nullable(),
    acknowledgedVersion: z.number().int().nullable(),
    /** Требуется подтверждение: регламент вступил в силу, а подтверждения нет. */
    acknowledgementRequired: z.boolean(),
    /** Льготный период истёк — доступ водителя должен быть ограничен. */
    graceExpired: z.boolean(),
    graceEndsAt: z.coerce.date().nullable(),
});
//# sourceMappingURL=policy.js.map